import theme from '@app/ui/theme'
import React from 'react'
import { FaAngleDown, FaAngleUp, FaBars } from 'react-icons/fa'
import Icon from '@ovaeasy/react-native-vector-icons/FontAwesome'

import { CSSObjectWithLabel } from 'react-select'
import styled from 'styled-components'
import { css } from 'styled-components'
import S from 'styled-components/native'

import { MENU_VIEWPORT_PADDING } from './menuFit'

const OL_DEFAULTWIDTH = 210
const OL_PADDING = 20
const isPhone = window.innerWidth <= 767

interface MenuOverlayProps {
  transform: string
  x?: number | string
  y?: number | string
  xAdj?: number | string
  yAdj?: number | string
  width: number
  zIndex?: number
  tablet?: boolean
  relative?: boolean
  left?: number
  maxHeight?: number | null
}

export const ClearIndicatorDiv = styled.div<{
  indicatorStyles: CSSObjectWithLabel
}>`
  // @ts-ignore
  ${(props) =>
    css`
      ${props.indicatorStyles as any}
    `}
  padding: 0px;
  padding-right: 8px;
`

export const MenuOverlay = styled.div`
  width: ${(props: MenuOverlayProps) =>
    props.width ? props.width : OL_DEFAULTWIDTH}px;
  background: ${theme.colors.white};
  padding: ${OL_PADDING}px;
  max-width: calc(100vw - ${(MENU_VIEWPORT_PADDING + OL_PADDING) * 2}px);
  margin-top: 50px;
  border-radius: 16px;
  position: fixed;
  z-index: ${(props: MenuOverlayProps) =>
    props.zIndex ? props.zIndex : '100'};
  user-select: none;
  transform: ${(props: MenuOverlayProps) => props.transform};
  box-shadow: 0 0px 40px 0 ${theme.colors.dark1};
  & > div:last-child {
    border-bottom: 0;
  }
  top: ${(props: MenuOverlayProps) => (props.y ? props.y : 70)}px;
  margin-left: ${(props: MenuOverlayProps) =>
    props.xAdj ? props.xAdj + 'px' : 0 + 'px'};
  margin-top: ${(props: MenuOverlayProps) =>
    props.yAdj ? props.yAdj + 'px' : 0 + 'px'};

  ${({ left }: MenuOverlayProps) =>
    typeof left === 'number'
      ? css`
          left: ${left}px;
          right: auto;
        `
      : ''}

  ${({ maxHeight }: MenuOverlayProps) =>
    maxHeight
      ? css`
          max-height: ${maxHeight}px;
          overflow-y: auto;
        `
      : ''}
`

interface DropDownProps {
  ref: React.RefObject<HTMLDivElement>
  style?: any
  backgroundColor?: string
  color?: string
  rounded?: boolean
  useShadow: boolean
}

interface DropDownSubMenuProps {
  style?: React.CSSProperties
  backgroundColor?: string
  color?: string
  rounded?: boolean
  useShadow: boolean
  width?: number
}

export const DropDown = styled.div<DropDownProps>`
  background-color: ${(props) => props.backgroundColor ?? theme.colors.white};
  box-shadow: ${(props) =>
    props.useShadow ? `0 0px 4px 0 ${theme.colors.dark1};` : `none`}
  height: 40px;
  line-height: 40px;
  padding-left: 14px;
  padding-right: 14px;
  border-radius: ${(props) => (props.rounded ? theme.borderRadius : 5)}px;
  display: flex;
  font-size: 16px;
  white-space: nowrap;
  font-weight: 500;
  color: ${(props) => props.color ?? '#333'};
  & > * {
    height: 40px;
  }
  margin-top: 0px;
  cursor: pointer;
  user-select: none;
  &:active {
    opacity: 0.7;
  }
  ${(props) => props.style}
`

export const DropDownIcon = styled(Icon)`
  height: 40px;
  margin-left: 10px;
  display: flex;
  align-items: center;
`

interface DropDownMenuItemProps {
  disabled?: boolean
}

export const DropDownMenuItem = S.TouchableOpacity`
  position: relative;
  display: block;
  padding:  ${!isPhone ? '10px' : '5px'};
  font-size: 15px;
  opacity: ${(props: DropDownMenuItemProps) => (props.disabled ? '0.6' : 1)};
  border-bottom-width: 1;
  border-bottom-color: ${theme.colors.light};
  padding-left: ${!isPhone ? '14px' : '7px'};
  padding-right: ${!isPhone ? '14px' : '7px'};
  line-height: ${!isPhone ? '40px' : '20px'};
  z-index:10;
`

export const DropDownSubMenuContainer = styled.div<DropDownSubMenuProps>`
  /* Expand inline below the row rather than flying out sideways: a side flyout can't
     stay on-screen at every trigger position without JS measurement, and the parent
     menu is clamped into the viewport. */
  position: relative;
  display: block;
  left: 0;
  top: 0;
  width: 100%;
  box-sizing: border-box;
  margin-top: 8px;
  max-height: 40vh;
  overflow-y: auto;
  padding: 5px;
  line-height: 30px;
  padding-left: 14px;
  padding-right: 14px;
  background-color: ${(props) => props.backgroundColor ?? theme.colors.white};
  border-radius: ${(props) => (props.rounded ? theme.borderRadius : 5)}px;
  box-shadow: ${(props) =>
    props.useShadow ? `0 0px 4px 0 ${theme.colors.dark1};` : `none`};

  & > div:last-child {
    border-bottom: 0;
  }
`

export const DropDownMenuSubItem = S.TouchableOpacity`
  display: block;
  padding: 10px;
  background-color: ${theme.colors.white};
  border-bottom-width: 1;
  border-bottom-color: ${theme.colors.light};
  font-size: 15px;
  opacity: ${(props: DropDownMenuItemProps) => (props.disabled ? '0.6' : 1)};
`

// For some reason iheritance is not working
export const BorderlessDropDownMenuItem = S.TouchableOpacity`
  display: block;
  padding: 10px;
  font-size: 15px;
  opacity: ${(props: DropDownMenuItemProps) => (props.disabled ? '0.6' : 1)};
  border: none;
`

// For some reason iheritance is not working
export const AdminTitle = styled.div`
  margin-top: 20px;
  font-weight: 200;
  text-align: left;
  font-size: 0.8em;
  line-height: 30px;
  z-index: 10;
`

export const DropDownMenuDiv = S.View`
  padding: 10px;
  border-bottom-width: 1;
  border-bottom-color: ${theme.colors.light};
  font-size: 15px;
`

export const DropDownTitleContainer = styled.div`
  margin-left: 10px;
  font-size: 14px;
  width: 100%;
`
export const DropDownIconContainer = styled.div<{
  noArrow: boolean
  hasTitle: boolean
  isOpen: boolean
  isMenu: boolean
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  margin-left: ${(props) => (!props.hasTitle ? 0 : !props.noArrow ? 8 : 10)}px;
  /* The title sits 10px in from the padding on its left, so the arrow needs the
     same on its right or it ends up closer to the edge than the text it belongs
     to. Menus without a title are centred by the padding alone. */
  margin-right: ${(props) => (props.hasTitle && !props.noArrow ? 10 : 0)}px;
  transform: rotate(
    ${(props) => (props.isOpen ? (props.isMenu ? 90 : 180) : 0)}deg
  );
  transition: transform 0.2s ease;
`
